import AppError from './app-error'

export default class ValidationError extends AppError {
  constructor(message: string = 'Validation error') {
    super()
    this.statusCode = 422
    this.handled = true // Don't report to Sentry, as this would normally be user error
    this.message = message
  }
}
